module.exports = __webpack_public_path__ + "img/CLAM.c83ec1b8.svg";